import initialState from '../../../redux/reducers/initial-state';
import actionTypes from '../../../redux/actions/action-types';

const customiseEditorPageReducer = (state = initialState.customiseEditorPage, action) => {
  switch (action.type) {
    case actionTypes.customiseEditorPage.set:
      return {
        ...state,
        ...action.data,
      };
  }
  return state;
};

export default customiseEditorPageReducer;
